"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { clsx } from 'clsx';
import { Row, Cell } from '../DataBuilderUI/index.mjs';
import { Textarea } from '../Textarea/index.mjs';
import classes from './SimpleInput.module.css.mjs';

function SimpleTextarea({
  label,
  value,
  onChange,
  ...props
}) {
  function handleChange(e) {
    onChange(e.target.value);
  }
  return /* @__PURE__ */ jsxs(Row, { className: clsx(classes.row, props?.disabled && classes.rowDisabled), children: [
    label && /* @__PURE__ */ jsx(Cell.Name, { children: /* @__PURE__ */ jsx("span", { className: "whitespace-nowrap", children: label }) }),
    /* @__PURE__ */ jsx(Cell, { className: classes.cell, grow: true, children: /* @__PURE__ */ jsx(
      Textarea,
      {
        value: value ?? "",
        onChange: handleChange,
        variant: "transparent",
        ...props,
        className: classes.textarea
      }
    ) })
  ] });
}
function SimpleTextareaWithLocalState({
  value,
  onChange,
  ...props
}) {
  const [localValue, setLocalValue] = useState(value);
  const [dirtyInput, setDirtyInput] = useState(false);
  useEffect(() => {
    if (!dirtyInput) {
      setLocalValue(value);
    }
  }, [value, dirtyInput]);
  function handleLocalChange(value2) {
    setLocalValue(value2);
    setDirtyInput(true);
  }
  function handleFocus(e) {
    props?.onFocus?.(e);
    setDirtyInput(true);
  }
  function handleBlur(e) {
    props?.onBlur?.(e);
    handleChange();
  }
  function handleChange() {
    onChange(localValue);
    setDirtyInput(false);
  }
  function handleKeyUp(e) {
    props.onKeyUp?.(e);
    if (e.key === "Enter") {
      handleChange();
    }
  }
  return /* @__PURE__ */ jsx(
    SimpleTextarea,
    {
      value: localValue,
      onChange: handleLocalChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyUp: handleKeyUp,
      ...props
    }
  );
}
const DataBuilderSimpleTextarea = SimpleTextarea;

export { DataBuilderSimpleTextarea, SimpleTextarea, SimpleTextareaWithLocalState };
